import React from "react";
import { Form } from "react-bootstrap";

const InputRadio = (props) => {
  return (
    <Form.Check
      inline
      name={props.Name}
      type="radio"
      defaultChecked={props.checkd}
      onChange={props.myChange}
      label={"Price " + props.lab + " (₦" + props.price + ")"}
      value={props.price}
      style={{ marginTop: "0px", marginBottom: "0px" }}
      disabled={!props.price}
    />
  );
};

export default InputRadio;
